///////////////////////////////////////////////////

import { apiConnector } from 'apiConnector/secondary-market/dlpApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import {
  secondaryMarketDlpProductFetched,
  secondaryMarketDlpProductFetchFailed,
  secondaryMarketDlpProductFetchProductNotFound,
} from 'state/secondaryMarket/referential/dlpProduct/dlpProduct.actions';
import type { EpicWithThunk } from 'state/state.common';
import { secondaryDlpQuoteTabCreatedThunk } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';
import type { HttpError } from 'utils/http/httpClient.model';

export function loadDlpProductEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { loadDlpProduct } = apiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_DLP_PRODUCT_FETCH_REQUESTED'),
      mergeMap(({ isin, tabId, createTabOnDlpProductFetched }) => {
        return loadDlpProduct(isin).pipe(
          mergeMap(data => {
            if (data === 'not_found') {
              const notFound = secondaryMarketDlpProductFetchProductNotFound(isin);
              if (createTabOnDlpProductFetched) {
                const showNotification = showNotificationThunk({
                  level: 'danger',
                  title: { id: 'secondaryMarket.errors.productNotFound.external.title' },
                  content: [{ id: 'secondaryMarket.errors.technical.external', values: { isin } }],
                  closeAutomatically: true,
                });
                return of(notFound, showNotification);
              }
              return of(notFound);
            }
            const productFetched = secondaryMarketDlpProductFetched(isin, data);
            if (tabId) {
              return of(productFetched);
            }

            if (createTabOnDlpProductFetched && !!isin) {
              return of(productFetched, secondaryDlpQuoteTabCreatedThunk(isin));
            }
            return of(productFetched);
          }),
          catchError((err: HttpError) => of(secondaryMarketDlpProductFetchFailed(isin, err.message))),
        );
      }),
    );
  };
}
